const initialData = {
    bookings: [],
    loading: false,
    error: null,
};

const bookingsReducer = (state = initialData, action) => {
    switch (action.type) {
        case 'GET_ALL_BOOKINGS': {
            return {
                ...state,
                bookings: action.payload,
                loading: false, // Set loading to false after fetching
            };
        }
        case 'LOADING': {
            return {
                ...state,
                loading: action.payload,
            };
        }
        default:
            return state;
    }
};

export default bookingsReducer;
